import Vue from 'vue';
import Router from 'vue-router';
import {beforeEachGuard} from '@/routes/router.guards';
import AdminTopLayout from '@/components/SAccTopLayout.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_ROUTER_BASE_URL,
  routes: [
    {
      path: '',
      component: AdminTopLayout,
      children: [
        {
          path: 'repository',
          name: 'repository',
          component: () => import('@/components/projects/SAccProjects.vue')
        },
        {
          path: 'users',
          name: 'users',
          component: () => import('@/components/users/SAccUsers.vue')
        },
        {
          path: 'home',
          name: 'home',
          component: () => import('@/components/SAccHomePage.vue')
        },
        {
          path: 'freetrial',
          name: 'freetrial',
          component: () => import('@/components/freetrial/SAccFreetrial.vue')
        },
        {
          path: '',
          redirect: {name: 'home'}
        }
      ]
    },
    {
      path: '/login',
      name: 'adminlogin',
      component: () => import('@/components/SAccLogin.vue')
    }
  ]
});

router.beforeEach(beforeEachGuard);

export default router;
